var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('Navbar'),_c('head-bar'),_c('div',[_c('app-main')],1),(_vm.currentRoute != '/register/index')?_c('ServiceBtn'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }